import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNgModule } from "@primeng";

import { GridModule } from "@features/grid";
import { WidgetGridComponent } from "./components/widget-grid.component";
import { WidgetGridBuilderComponent } from "./components/widget-grid-builder.component";
import { WidgetGridBuilderService } from "./api/widget-grid-builder.service";
import { ReportingCoreModule } from "../reporting-core.module";
import { QueryBuilderModule } from "../query-builder/query-builder.module";
import { WidgetGridCustomFormatTooltipComponent } from "./components/widget-grid-custom-format-tooltip.component";
import { WidgetGridPdfExportingService } from "@main/reporting.v3/widget.grid/api/widget-grid-pdf-exporting.service";
import { WidgetGridXlsExportingService } from "@main/reporting.v3/widget.grid/api/widget-grid-xls-exporting.service";
import { WidgetActionMenuComponent } from "@main/reporting.v3/widget.grid/components/widget-action-menu.component";
import { WidgetGridAuxiliaryService } from "@main/reporting.v3/widget.grid/api/widget-grid-auxiliary.service";
import { RichTextEditorModule } from "@controls/text-editors/rich-text-editor/rich-text-editor.module";
import { WidgetGridViewService } from "@main/reporting.v3/widget.grid/api/widget-grid-view.service";
import { WidgetGridDataService } from "@main/reporting.v3/widget.grid/api/widget-grid-data.service";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { BbTooltipModule } from "@features/bb-tooltip";
import { PaginatorModule } from "primeng/paginator";
import { MenuModule } from "primeng/menu";


@NgModule({
    declarations: [
        WidgetGridComponent,
        WidgetActionMenuComponent,
        WidgetGridBuilderComponent,
        WidgetGridCustomFormatTooltipComponent
    ],
    exports: [
        WidgetGridComponent,
        WidgetGridBuilderComponent,
        WidgetGridCustomFormatTooltipComponent
    ],
    imports: [
        GridModule,
        MenuModule,
        CommonModule,
        PrimeNgModule,
        ReportingCoreModule,
        QueryBuilderModule,
        PaginatorModule,
        BbwtSharedModule,
        BbTooltipModule,

        QueryBuilderModule,
        RichTextEditorModule,

        ReportingCoreModule,
    ],
    providers: [
        WidgetGridPdfExportingService,
        WidgetGridXlsExportingService,
        WidgetGridAuxiliaryService,
        WidgetGridBuilderService,
        WidgetGridViewService,
        WidgetGridDataService
    ]
})
export class WidgetGridModule {
}